import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IUpsertCompanyAssociations } from 'views/DealDashboard/types';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface IVariables extends IUpsertCompanyAssociations { organizationId: string }

const useUpsertCompanyAssociations = (
    options: Omit<UseMutationOptions<void, AxiosError, IVariables>, 'mutationFn'> = {},
) => useMutation({
    mutationFn: async (variables: IVariables) => {
        const { organizationId, ...payload } = variables;
        const res = await axiosInstance.post<void>(
            API_ENDPOINTS.CRM.COMPANY_ASSOCIATIONS(organizationId),
            payload,
        );
        return res.data;
    },
    ...options,
});

export default useUpsertCompanyAssociations;
